module.exports = __webpack_public_path__ + "static/media/sal-pruhled.9a23e2d9.jpg";